import { render } from "./AmiPage.vue?vue&type=template&id=1420eeb8&scoped=true"
import script from "./AmiPage.vue?vue&type=script&lang=js"
export * from "./AmiPage.vue?vue&type=script&lang=js"

import "./AmiPage.vue?vue&type=style&index=0&id=1420eeb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1420eeb8"]])

export default __exports__